// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import notificationApi from '~/apis/notification';
import { GET_LIST_NOTIFICATION, READ_NOTIFICATION } from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';

export const getListNotification = createAsyncThunk(
  GET_LIST_NOTIFICATION,
  async (payload: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await notificationApi.getListNotification(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readNotification = createAsyncThunk(
  READ_NOTIFICATION,
  async (notificationId: string, { rejectWithValue }) => {
    try {
      const resp = await notificationApi.readNotification(notificationId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
